import { createRouter, createWebHistory } from 'vue-router'
import { consumeImpersonationHash } from './api.js'

// Must run before createWebHistory() reads window.location, or the router
// restores the #imp= fragment on its first navigation.
consumeImpersonationHash()

const routes = [
  // Participant
  { path: '/', component: () => import('./pages/Home.vue'), meta: { layout: 'participant' } },
  { path: '/t/:code', component: () => import('./pages/Tap.vue'), meta: { layout: 'participant' } },
  { path: '/stops', component: () => import('./pages/Stops.vue'), meta: { layout: 'participant' } },
  { path: '/vote', component: () => import('./pages/VoteIndex.vue'), meta: { layout: 'participant' } },
  { path: '/vote/:code', component: () => import('./pages/Vote.vue'), meta: { layout: 'participant' } },
  { path: '/prizes', component: () => import('./pages/Prizes.vue'), meta: { layout: 'participant' } },
  { path: '/login', component: () => import('./pages/Login.vue'), meta: { layout: 'participant' } },

  // Kiosks (the only pages that open Pusher sockets)
  { path: '/leaderboard', component: () => import('./pages/Leaderboard.vue'), meta: { kiosk: true } },
  { path: '/drawing', component: () => import('./pages/Drawing.vue'), meta: { kiosk: true } },
  { path: '/vote-results', component: () => import('./pages/VoteResults.vue'), meta: { kiosk: true } },
  { path: '/vote-results/:code', component: () => import('./pages/VoteResults.vue'), meta: { kiosk: true } },

  // Admin
  { path: '/admin/login', component: () => import('./pages/admin/Login.vue') },
  { path: '/admin/forgot', component: () => import('./pages/admin/Forgot.vue') },
  { path: '/admin/reset', component: () => import('./pages/admin/Reset.vue') },
  {
    path: '/admin',
    component: () => import('./pages/admin/Layout.vue'),
    children: [
      { path: '', redirect: '/admin/events' },
      { path: 'events', component: () => import('./pages/admin/Events.vue') },
      { path: 'events/:id', component: () => import('./pages/admin/EventEdit.vue') },
      { path: 'booths', component: () => import('./pages/admin/Booths.vue') },
      { path: 'tags', component: () => import('./pages/admin/Tags.vue') },
      { path: 'votes', component: () => import('./pages/admin/Votes.vue') },
      { path: 'announcements', component: () => import('./pages/admin/Announcements.vue') },
      { path: 'participants', component: () => import('./pages/admin/Participants.vue') },
      { path: 'reports', component: () => import('./pages/admin/Reports.vue') },
      { path: 'prizes', component: () => import('./pages/admin/Prizes.vue') },
      { path: 'cards', component: () => import('./pages/admin/Cards.vue') },
      { path: 'admins', component: () => import('./pages/admin/Admins.vue') },
      { path: 'account', component: () => import('./pages/admin/Account.vue') }
    ]
  },

  { path: '/:pathMatch(.*)*', component: () => import('./pages/NotFound.vue') }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior: () => ({ top: 0 })
})

// Chunk load failures after a deploy: reload once instead of showing a dead page.
router.onError((err, to) => {
  if (/Failed to fetch dynamically imported module|Importing a module script failed|Loading chunk/i.test(String(err?.message))) {
    const key = 'quest_reloaded_for'
    if (sessionStorage.getItem(key) !== to.fullPath) {
      sessionStorage.setItem(key, to.fullPath)
      window.location.assign(to.fullPath)
    }
  }
})

export default router
